import config from '../../../../config/index';

export default {
  data() {
    return {
      // 配置文件获取当前区域和系统类型
      areaId: config.web.areaId,
      areaName: config.web.areaName,
      studentType: config.web.systemLevel === 'kinder' ? 1 : (config.web.systemLevel === 'school' ? 2 : 0),
      studentTypeName: '',
      studentTypeUpName: '',
      sysName: '报名'
    };
  },
  created() {
    // 重写Message方法
    this.$message.loading = () => {};
    this.$message.hide = () => {};

    if (this.studentType === 1) {
      this.studentTypeName = '幼儿';
			this.studentTypeUpName = '幼儿园';
			this.studentTypeName2 = '幼儿';
    } else {
			this.studentTypeName = '学生';
			this.studentTypeName2 = '随迁子女';
      this.studentTypeUpName = '街道';
      this.sysName = '填报';
    }

    // setIsMobile
    // this.$store.commit('setIsMobile', false);
    // document.body.style.backgroundColor = "#ffffff";
    // document.getElementsByTagName("html")[0].backgroundColor = "#ffffff";
  },
  watch: {},
  methods: {}
};
